import React from 'react';
import './ProgressBar.css';
export default function UploadBar(anonymized, upload){
    if (!anonymized && upload) {
        return (
            <React.Fragment>
                <div className="progress-bar" id="ProgressBar">
                    <div className="progress-bar-fill">
                        <span className="progress-bar-text"> Anonymizing... </span>
                    </div>
                </div>
            </React.Fragment>
            );
    }
    if (anonymized && upload){
        return (
            <React.Fragment>
            <div className="progress-bar" id="progressBar">
                <div className="progress-bar-fill">
                    <span className="progress-bar-text"> 0% </span>
                </div>
             </div>
            </React.Fragment>

            )
    }
}